import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { getTextByLang } from '../ExternalFields'
import { useStore } from '../../StateProvider'

const HeadTags = () => {
  const { t, i18n } = useTranslation()
  const [{ whitelabel }] = useStore()
  const { customTexts, favicon } = whitelabel

  useEffect(() => {
    document.title = getTextByLang('pageTitle', customTexts, t('page.title'))

    const link = document.createElement('meta')
    link.name = 'description'
    link.content = getTextByLang('pageDescription', customTexts, t('page.description'))
    document.getElementsByTagName('head')[0].appendChild(link)

    if (favicon) {
      /**
       * @type {HTMLLinkElement}
       */
      const faviconLink = document.getElementById('favicon')
      faviconLink.href = `data:image/x-icon;base64,${favicon}`
    }
  }, [customTexts, favicon, i18n.language])

  return null
}

export default HeadTags
